module.exports = __webpack_public_path__ + "images/2b06ecebafaefa9b107aca8f891db94e.png";